module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.getScreenSize < 2 && !_vm.delayedLoading[6]),
      expression: "getScreenSize < 2 && !delayedLoading[6]"
    }],
    ref: "form",
    attrs: {
      "label-position": "top",
      "element-loading-text": "Loading..."
    }
  }, [_c('el-row', [_c('el-dialog', {
    attrs: {
      "title": "New group",
      "visible": _vm.newGroup,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.newGroup = $event
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$l('settings/alertMessaging/createGroupDialog')) + " ")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.newGroup = false
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/alertMessaging/dialogCancel')) + " ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.newGroup = false;
        _vm.addGroup()
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/alertMessaging/dialogConfirm')) + " ")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.$l('settings/alertMessaging/deleteGroupDialog')) + " " + _vm._s(_vm.deleteGroup.replace('gr', '')))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/alertMessaging/dialogCancel')) + "  ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false;
        _vm.removeGroup(_vm.deleteGroup)
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/alertMessaging/dialogConfirm')) + "  ")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Tips",
      "visible": _vm.dialogVisible1,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible1 = $event
      }
    }
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.$l('settings/alertMessaging/deleteEmailDialog')))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible1 = false
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/alertMessaging/dialogCancel')) + "  ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible1 = false, _vm.deleteRecipient(_vm.deleteRecipientGroup)
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$l('settings/alertMessaging/dialogConfirm')) + "  ")])], 1)]), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[1]) ? _c('el-form-item', {
    staticClass: "el-form-item-full"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.newGroup = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$l('settings/alertMessaging/createGroupButton')))])], 1) : _vm._e(), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[2]) ? _c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "lg": 24,
      "md": 24,
      "sm": 24
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/alertMessaging/MSISDN-E-Mail')
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.selectedGroups),
      callback: function($$v) {
        _vm.selectedGroups = $$v
      },
      expression: "selectedGroups"
    }
  }, _vm._l((_vm.getSettingsAlertMessaging.groups), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": 'Group ' + item.replace('gr', ''),
        "value": item
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 10,
      "md": 9,
      "sm": 9
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/alertMessaging/Add MSISDN')
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "90%"
    },
    model: {
      value: (_vm.selectedNumber),
      callback: function($$v) {
        _vm.selectedNumber = $$v
      },
      expression: "selectedNumber"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 10,
      "md": 9,
      "sm": 9
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/alertMessaging/Add E-mail')
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.selectedEmail),
      callback: function($$v) {
        _vm.selectedEmail = $$v
      },
      expression: "selectedEmail"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 2,
      "md": 5,
      "sm": 5
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": " "
    }
  }, [_c('el-button', {
    staticClass: "AddEmailButton",
    attrs: {
      "size": "small",
      "type": "danger",
      "icon": "plus"
    },
    on: {
      "click": _vm.addRecipientClicked
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$l('settings/addButt')))])])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[3]) ? _c('el-collapse', {
    attrs: {
      "accordion": ""
    }
  }, [_vm._l((_vm.getSettingsAlertMessaging.groups), function(group, index) {
    return (_vm.getScreenSize > 1 || _vm.delayedLoading[4]) ? _c('el-collapse-item', {
      key: index,
      attrs: {
        "title": 'Group ' + (group.replace('gr', ''))
      }
    }, [_c('el-row', {
      attrs: {
        "gutter": 25
      }
    }, [_c('el-col', {
      attrs: {
        "sm": 5,
        "md": 3
      }
    }, [_c('el-button', {
      staticClass: "buttons",
      attrs: {
        "title": _vm.$l('settings/alertMessaging/DeleteGroup'),
        "size": "mini",
        "type": "danger",
        "icon": "delete"
      },
      on: {
        "click": function($event) {
          _vm.dialogVisible = true;
          _vm.deleteGroup = group
        }
      }
    }, [_vm._v(_vm._s(_vm.$l('settings/alertMessaging/DeleteGroup')) + " ")])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "sm": 3,
        "md": 3
      }
    }, [_c('el-button', {
      staticClass: "buttons",
      attrs: {
        "title": _vm.$l('settings/alertMessaging/TestEmail'),
        "size": "mini",
        "type": "success",
        "icon": "share"
      },
      on: {
        "click": function($event) {
          return _vm.sendTestMail(group)
        }
      }
    }, [_vm._v(_vm._s(_vm.$l('settings/alertMessaging/TestEmail')))])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "sm": 19,
        "md": 19
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": _vm.$l('settings/alertMessaging/DeleteRecip')
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": _vm.$l('common/select')
      },
      model: {
        value: (_vm.getSettingsAlertMessaging['del' + group.replace('gr', '')]),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsAlertMessaging, 'del' + group.replace('gr', ''), $$v)
        },
        expression: "getSettingsAlertMessaging['del'+group.replace('gr','')]"
      }
    }, _vm._l((_vm.getSettingsAlertMessaging['recpg' + group.replace('gr', '')]), function(item) {
      return _c('el-option', {
        key: item,
        attrs: {
          "label": item,
          "value": item
        }
      })
    }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "lg": 5,
        "md": 5,
        "sm": 5
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": " "
      }
    }, [_c('el-button', {
      staticClass: "DeleteEmailButton",
      attrs: {
        "size": "small",
        "type": "danger",
        "icon": "plus"
      },
      on: {
        "click": function($event) {
          _vm.dialogVisible1 = true;
          _vm.deleteRecipientGroup = group
        }
      }
    }, [_c('b', [_vm._v(_vm._s(_vm.$l('settings/alertMessaging/DeleteButton')))])])], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "lg": 12,
        "sm": 24
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": _vm.$l('settings/alertMessaging/Threshold day')
      }
    }, [_c('el-row', [_c('el-col', {
      attrs: {
        "md": 6
      }
    }, [_c('el-switch', {
      attrs: {
        "on-text": "",
        "off-text": ""
      },
      model: {
        value: (_vm.getSettingsAlertMessaging['alg' + group.replace('gr', '')]['threshday']),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsAlertMessaging['alg' + group.replace('gr', '')], 'threshday', $$v)
        },
        expression: "getSettingsAlertMessaging['alg'+group.replace('gr','')]['threshday']"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "md": 18
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": _vm.$l('common/select')
      },
      model: {
        value: (_vm.getSettingsAlertMessaging['repg' + group.replace('gr', '')][0]),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsAlertMessaging['repg' + group.replace('gr', '')], 0, $$v)
        },
        expression: "getSettingsAlertMessaging['repg'+group.replace('gr','')][0]"
      }
    }, [_c('el-option', {
      attrs: {
        "label": _vm.$l('settings/alertMessaging/noRepeat'),
        "value": "0"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '1 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "1"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '5 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "5"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '10 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "10"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '15 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "15"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '30 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "30"
      }
    })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "lg": 12,
        "sm": 24
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": _vm.$l('settings/alertMessaging/Threshold Night')
      }
    }, [_c('el-row', [_c('el-col', {
      attrs: {
        "md": 6
      }
    }, [_c('el-switch', {
      attrs: {
        "on-text": "",
        "off-text": ""
      },
      model: {
        value: (_vm.getSettingsAlertMessaging['alg' + group.replace('gr', '')]['threshnight']),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsAlertMessaging['alg' + group.replace('gr', '')], 'threshnight', $$v)
        },
        expression: "getSettingsAlertMessaging['alg'+group.replace('gr','')]['threshnight']"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "md": 18
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": _vm.$l('common/select')
      },
      model: {
        value: (_vm.getSettingsAlertMessaging['repg' + group.replace('gr', '')][1]),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsAlertMessaging['repg' + group.replace('gr', '')], 1, $$v)
        },
        expression: "getSettingsAlertMessaging['repg'+group.replace('gr','')][1]"
      }
    }, [_c('el-option', {
      attrs: {
        "label": _vm.$l('settings/alertMessaging/noRepeat'),
        "value": "0"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '1 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "1"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '5 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "5"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '10 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "10"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '15 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "15"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '30 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "30"
      }
    })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "lg": 12,
        "sm": 24
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": _vm.$l('settings/alertMessaging/Threshold Opt 1')
      }
    }, [_c('el-row', [_c('el-col', {
      attrs: {
        "md": 6
      }
    }, [_c('el-switch', {
      attrs: {
        "on-text": "",
        "off-text": ""
      },
      model: {
        value: (_vm.getSettingsAlertMessaging['alg' + group.replace('gr', '')]['threshopt1']),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsAlertMessaging['alg' + group.replace('gr', '')], 'threshopt1', $$v)
        },
        expression: "getSettingsAlertMessaging['alg'+group.replace('gr','')]['threshopt1']"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "md": 18
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": _vm.$l('common/select')
      },
      model: {
        value: (_vm.getSettingsAlertMessaging['repg' + group.replace('gr', '')][2]),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsAlertMessaging['repg' + group.replace('gr', '')], 2, $$v)
        },
        expression: "getSettingsAlertMessaging['repg'+group.replace('gr','')][2]"
      }
    }, [_c('el-option', {
      attrs: {
        "label": _vm.$l('settings/alertMessaging/noRepeat'),
        "value": "0"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '1 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "1"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '5 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "5"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '10 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "10"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '15 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "15"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '30 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "30"
      }
    })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "lg": 12,
        "sm": 24
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": _vm.$l('settings/alertMessaging/Threshold Opt 2')
      }
    }, [_c('el-row', [_c('el-col', {
      attrs: {
        "md": 6
      }
    }, [_c('el-switch', {
      attrs: {
        "on-text": "",
        "off-text": ""
      },
      model: {
        value: (_vm.getSettingsAlertMessaging['alg' + group.replace('gr', '')]['threshopt2']),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsAlertMessaging['alg' + group.replace('gr', '')], 'threshopt2', $$v)
        },
        expression: "getSettingsAlertMessaging['alg'+group.replace('gr','')]['threshopt2']"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "md": 18
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": _vm.$l('common/select')
      },
      model: {
        value: (_vm.getSettingsAlertMessaging['repg' + group.replace('gr', '')][3]),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsAlertMessaging['repg' + group.replace('gr', '')], 3, $$v)
        },
        expression: "getSettingsAlertMessaging['repg'+group.replace('gr','')][3]"
      }
    }, [_c('el-option', {
      attrs: {
        "label": _vm.$l('settings/alertMessaging/noRepeat'),
        "value": "0"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '1 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "1"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '5 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "5"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '10 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "10"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '15 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "15"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '30 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "30"
      }
    })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "lg": 12,
        "sm": 24
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": _vm.$l('settings/alertMessaging/Running Average Level')
      }
    }, [_c('el-row', [_c('el-col', {
      attrs: {
        "md": 6
      }
    }, [_c('el-switch', {
      attrs: {
        "on-text": "",
        "off-text": ""
      },
      model: {
        value: (_vm.getSettingsAlertMessaging['alg' + group.replace('gr', '')]['mav']),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsAlertMessaging['alg' + group.replace('gr', '')], 'mav', $$v)
        },
        expression: "getSettingsAlertMessaging['alg'+group.replace('gr','')]['mav']"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "md": 18
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": _vm.$l('common/select')
      },
      model: {
        value: (_vm.getSettingsAlertMessaging['repg' + group.replace('gr', '')][4]),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsAlertMessaging['repg' + group.replace('gr', '')], 4, $$v)
        },
        expression: "getSettingsAlertMessaging['repg'+group.replace('gr','')][4]"
      }
    }, [_c('el-option', {
      attrs: {
        "label": _vm.$l('settings/alertMessaging/noRepeat'),
        "value": "0"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '1 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "1"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '5 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "5"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '10 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "10"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '15 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "15"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '30 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "30"
      }
    })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "lg": 12,
        "sm": 24
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": _vm.$l('settings/alertMessaging/Weather trigger')
      }
    }, [_c('el-row', [_c('el-col', {
      attrs: {
        "md": 6
      }
    }, [_c('el-switch', {
      attrs: {
        "on-text": "",
        "off-text": ""
      },
      model: {
        value: (_vm.getSettingsAlertMessaging['alg' + group.replace('gr', '')]['weatTrig']),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsAlertMessaging['alg' + group.replace('gr', '')], 'weatTrig', $$v)
        },
        expression: "getSettingsAlertMessaging['alg'+group.replace('gr','')]['weatTrig']"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "md": 18
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": _vm.$l('common/select')
      },
      model: {
        value: (_vm.getSettingsAlertMessaging['repg' + group.replace('gr', '')][5]),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsAlertMessaging['repg' + group.replace('gr', '')], 5, $$v)
        },
        expression: "getSettingsAlertMessaging['repg'+group.replace('gr','')][5]"
      }
    }, [_c('el-option', {
      attrs: {
        "label": _vm.$l('settings/alertMessaging/noRepeat'),
        "value": "0"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '1 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "1"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '5 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "5"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '10 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "10"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '15 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "15"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '30 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "30"
      }
    })], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
      attrs: {
        "lg": 12
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": _vm.$l('settings/alertMessaging/System reboot')
      }
    }, [_c('el-switch', {
      attrs: {
        "on-text": "",
        "off-text": ""
      },
      model: {
        value: (_vm.getSettingsAlertMessaging['alg' + group.replace('gr', '')]['reboot']),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsAlertMessaging['alg' + group.replace('gr', '')], 'reboot', $$v)
        },
        expression: "getSettingsAlertMessaging['alg'+group.replace('gr','')]['reboot']"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "lg": 12
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": _vm.$l('settings/alertMessaging/Critical disk space')
      }
    }, [_c('el-switch', {
      attrs: {
        "on-text": "",
        "off-text": ""
      },
      model: {
        value: (_vm.getSettingsAlertMessaging['alg' + group.replace('gr', '')]['discerr']),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsAlertMessaging['alg' + group.replace('gr', '')], 'discerr', $$v)
        },
        expression: "getSettingsAlertMessaging['alg'+group.replace('gr','')]['discerr']"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "lg": 12
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": _vm.$l('settings/alertMessaging/Connection with meter lost')
      }
    }, [_c('el-switch', {
      attrs: {
        "on-text": "",
        "off-text": ""
      },
      model: {
        value: (_vm.getSettingsAlertMessaging['alg' + group.replace('gr', '')]['n140']),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsAlertMessaging['alg' + group.replace('gr', '')], 'n140', $$v)
        },
        expression: "getSettingsAlertMessaging['alg'+group.replace('gr','')]['n140']"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "lg": 12
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": _vm.$l('settings/alertMessaging/Critical memory on meter')
      }
    }, [_c('el-switch', {
      attrs: {
        "on-text": "",
        "off-text": ""
      },
      model: {
        value: (_vm.getSettingsAlertMessaging['alg' + group.replace('gr', '')]['n140sd']),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsAlertMessaging['alg' + group.replace('gr', '')], 'n140sd', $$v)
        },
        expression: "getSettingsAlertMessaging['alg'+group.replace('gr','')]['n140sd']"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "lg": 12
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": _vm.$l('settings/alertMessaging/Microphone check error')
      }
    }, [_c('el-switch', {
      attrs: {
        "on-text": "",
        "off-text": ""
      },
      model: {
        value: (_vm.getSettingsAlertMessaging['alg' + group.replace('gr', '')]['micerr']),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsAlertMessaging['alg' + group.replace('gr', '')], 'micerr', $$v)
        },
        expression: "getSettingsAlertMessaging['alg'+group.replace('gr','')]['micerr']"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "lg": 12
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": _vm.$l('settings/alertMessaging/FTP server error')
      }
    }, [_c('el-switch', {
      attrs: {
        "on-text": "",
        "off-text": ""
      },
      model: {
        value: (_vm.getSettingsAlertMessaging['alg' + group.replace('gr', '')]['ftperr']),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsAlertMessaging['alg' + group.replace('gr', '')], 'ftperr', $$v)
        },
        expression: "getSettingsAlertMessaging['alg'+group.replace('gr','')]['ftperr']"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "lg": 12
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": _vm.$l('settings/alertMessaging/Battery mode')
      }
    }, [_c('el-switch', {
      attrs: {
        "on-text": "",
        "off-text": ""
      },
      model: {
        value: (_vm.getSettingsAlertMessaging['alg' + group.replace('gr', '')]['battmode']),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsAlertMessaging['alg' + group.replace('gr', '')], 'battmode', $$v)
        },
        expression: "getSettingsAlertMessaging['alg'+group.replace('gr','')]['battmode']"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "lg": 12
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": _vm.$l('settings/alertMessaging/Connection with Weather station lost')
      }
    }, [_c('el-switch', {
      attrs: {
        "on-text": "",
        "off-text": ""
      },
      model: {
        value: (_vm.getSettingsAlertMessaging['alg' + group.replace('gr', '')]['weather']),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsAlertMessaging['alg' + group.replace('gr', '')], 'weather', $$v)
        },
        expression: "getSettingsAlertMessaging['alg'+group.replace('gr','')]['weather']"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
      attrs: {
        "lg": 4
      }
    }, [_c('el-col', {
      attrs: {
        "lg": 24
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": _vm.$l('settings/alertMessaging/LEQ')
      }
    }, [_c('el-switch', {
      attrs: {
        "on-text": "",
        "off-text": ""
      },
      model: {
        value: (_vm.getSettingsAlertMessaging['alg' + group.replace('gr', '')]['leqday']),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsAlertMessaging['alg' + group.replace('gr', '')], 'leqday', $$v)
        },
        expression: "getSettingsAlertMessaging['alg'+group.replace('gr','')]['leqday']"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "lg": 20
      }
    }, [(_vm.getSettingsAlertMessaging['alg' + group.replace('gr', '')]['leqday']) ? _c('div', {
      staticClass: "LEQContainer"
    }, [_c('el-row', {
      attrs: {
        "gutter": 20
      }
    }, [_c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": _vm.$l('settings/alertMessaging/resendAft')
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": _vm.$l('common/select')
      },
      model: {
        value: (_vm.getSettingsAlertMessaging['repg' + group.replace('gr', '')][6]),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsAlertMessaging['repg' + group.replace('gr', '')], 6, $$v)
        },
        expression: "getSettingsAlertMessaging['repg'+group.replace('gr','')][6]"
      }
    }, [_c('el-option', {
      attrs: {
        "label": _vm.$l('settings/alertMessaging/noRepeat'),
        "value": "0"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '1 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "1"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '5 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "5"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '10 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "10"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '15 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "15"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": '30 ' + _vm.$l('settings/alertMessaging/min'),
        "value": "30"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 16
      }
    }, [_c('el-row', {
      attrs: {
        "type": "flex",
        "justify": "space-between",
        "gutter": 25
      }
    }, [_c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": _vm.$l('settings/preTrigg')
      }
    }, [_c('el-row', [_c('el-col', {
      attrs: {
        "span": 4
      }
    }, [_c('el-checkbox', {
      model: {
        value: (_vm.getSettingsAlertMessaging['lqtg' + group.replace('gr', '')][0]),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsAlertMessaging['lqtg' + group.replace('gr', '')], 0, $$v)
        },
        expression: "getSettingsAlertMessaging['lqtg'+group.replace('gr','')][0]"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 20
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "100%"
      },
      model: {
        value: (_vm.getSettingsAlertMessaging['leqdg' + group.replace('gr', '')][0]),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsAlertMessaging['leqdg' + group.replace('gr', '')], 0, $$v)
        },
        expression: "getSettingsAlertMessaging['leqdg'+group.replace('gr','')][0]"
      }
    }, [_c('template', {
      slot: "prepend"
    }, [_vm._v("-")])], 2)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": _vm.$l('settings/Trigg')
      }
    }, [_c('el-row', [_c('el-col', {
      attrs: {
        "span": 4
      }
    }, [_c('el-checkbox', {
      model: {
        value: (_vm.getSettingsAlertMessaging['lqtg' + group.replace('gr', '')][1]),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsAlertMessaging['lqtg' + group.replace('gr', '')], 1, $$v)
        },
        expression: "getSettingsAlertMessaging['lqtg'+group.replace('gr','')][1]"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 20
      }
    }, [_c('el-input', {
      attrs: {
        "disabled": "",
        "value": _vm.getSettingsSpecval.leqdayval
      }
    })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('el-form-item', {
      staticClass: "el-form-item-full",
      attrs: {
        "label": _vm.$l('settings/postTrigg')
      }
    }, [_c('el-row', [_c('el-col', {
      attrs: {
        "span": 4
      }
    }, [_c('el-checkbox', {
      model: {
        value: (_vm.getSettingsAlertMessaging['lqtg' + group.replace('gr', '')][2]),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsAlertMessaging['lqtg' + group.replace('gr', '')], 2, $$v)
        },
        expression: "getSettingsAlertMessaging['lqtg'+group.replace('gr','')][2]"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 20
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "100%"
      },
      model: {
        value: (_vm.getSettingsAlertMessaging['leqdg' + group.replace('gr', '')][1]),
        callback: function($$v) {
          _vm.$set(_vm.getSettingsAlertMessaging['leqdg' + group.replace('gr', '')], 1, $$v)
        },
        expression: "getSettingsAlertMessaging['leqdg'+group.replace('gr','')][1]"
      }
    }, [_c('template', {
      slot: "prepend"
    }, [_vm._v("+")])], 2)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e()])], 1)], 1) : _vm._e()
  }), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[5]) ? _c('el-collapse-item', {
    attrs: {
      "title": _vm.$l('settings/alertMessaging/Inbound (MSISDN)')
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "md": 24
    }
  }, [_c('div', {
    staticClass: "Container"
  }, [_vm._v(_vm._s(_vm.$l('settings/alertMessaging/Status')) + " status")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 24
    }
  }, [_c('div', {
    staticClass: "Container"
  }, [_vm._v(_vm._s(_vm.$l('settings/alertMessaging/GPS')) + " gps")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 24
    }
  }, [_c('div', {
    staticClass: "Container"
  }, [_vm._v(_vm._s(_vm.$l('settings/alertMessaging/Threshold change')) + " threshold day/night/opt1/opt2 60 admin password")])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$p('settings/alertMessaging/emailsett') && (_vm.getScreenSize > 1 || _vm.delayedLoading[6])) ? _c('el-collapse-item', {
    attrs: {
      "title": _vm.$l('settings/alertMessaging/Email settings')
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [(_vm.$p('settings/alertMessaging/sender')) ? _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/alertMessaging/Sender Email')
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.getSettingsAddons.email == '0'
    },
    model: {
      value: (_vm.getSettingsEmail.user),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsEmail, "user", $$v)
      },
      expression: "getSettingsEmail.user"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$p('settings/alertMessaging/password')) ? _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getSettingsAddons.email == '1'),
      expression: "getSettingsAddons.email == '1'"
    }],
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/alertMessaging/Password')
    }
  }, [_c('el-input', {
    attrs: {
      "type": _vm.showPassword ? '' : 'password'
    },
    model: {
      value: (_vm.getSettingsEmail.pwd),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsEmail, "pwd", $$v)
      },
      expression: "getSettingsEmail.pwd"
    }
  }, [_c('el-button', {
    staticClass: "show-password-button",
    attrs: {
      "slot": "append"
    },
    on: {
      "click": function($event) {
        _vm.showPassword = !_vm.showPassword
      }
    },
    slot: "append"
  }, [_c('icon', {
    attrs: {
      "name": "eye"
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$p('settings/alertMessaging/smtp')) ? _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getSettingsAddons.email == '1'),
      expression: "getSettingsAddons.email == '1'"
    }],
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/alertMessaging/SMTP server')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.getSettingsEmail.smtp),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsEmail, "smtp", $$v)
      },
      expression: "getSettingsEmail.smtp"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$p('settings/alertMessaging/smtp')) ? _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getSettingsAddons.email == '1'),
      expression: "getSettingsAddons.email == '1'"
    }],
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/alertMessaging/SMTP port')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.getSettingsEmail.port),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsEmail, "port", $$v)
      },
      expression: "getSettingsEmail.port"
    }
  })], 1)], 1) : _vm._e()], 1)], 1) : _vm._e()], 2) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-608172a4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/categories/AlertMessaging.vue
// module id = 461
// module chunks = 1